import AjaxUtils from '../../util/ajax_utils';
import { ApckCredentialDetails } from './cred_table';
import { CredentialManagerFormSSR } from './cred_form';

export const ApckModalCredentialSelect = {
    props: {
        src: {
            type: String,
            default: ""
        },
        skip_password_check: {
            type: Boolean,
            default: false,
        },
        not_shared: {
            type: Boolean,
            default: false,
        },
        cred_type: {
            type: String,
            default: ""
        },
    },
    data: function () {
        return {
            showScriptList: false,
            cols: [
                {"minWidth": 150, "data": "description", "heading": "Description", "canSearch": true},
                {"width": 180, "data": "type", "heading": "Type", "canSearch": true, "ctype": "credtitlecolumn"},
                {"minWidth": 100, "data": "created_at", "heading": "Created", "ctype": "datecolumn"},
                {"minWidth": 100, "data": "updated_at", "heading": "Updated", "ctype": "datecolumn"},
                {"minWidth": 100, "data": "expiry_date", "heading": "Expiry Date", "ctype": "datecolumn"},
                {"minWidth": 100, "data": "is_active", "heading": "Active", "ctype": "boolcolumn"},
                {"minWidth": 100, "data": "used_count", "heading": "Times Used", "ctype": "column"},
            ],
            description: "",
            sort: "updated_at",
            dir: "desc",
            actions: [
                {
                    title: "Select",
                    icon: "fa-crosshairs-simple",
                    class: "btn-primary",
                    handler: this.selectCredential,
                }, {
                    title: "View details",
                    icon: "fa-eye",
                    class: "btn-primary",
                    handler: this.viewCred,
                }, {
                    title: "Edit",
                    icon: "fa-pencil",
                    class: "btn-secondary",
                    handler: this.editCred,
                }, {
                    title: "Delete",
                    icon: "fa-trash",
                    class: "btn-negative",
                    handler: this.deleteCred,
                }
            ],
        };
    },
    methods: {
        viewCred: function (row) {
            const cmp = this;
            const _viewCred = function(passwordValue, failureMessage) {
                AjaxUtils.ajax_post({
                    url: '/credman/credentials_secret/' + row.raw.uuid,
                    data: {
                        password: passwordValue,
                    },
                    success: function (resp) {
                        if (!resp.success) {
                            cmp.$dialog.alert(failureMessage, 'Failed');
                            return;
                        }

                        cmp.$lightbox.open({
                            title: "Credential Details",
                            component: ApckCredentialDetails,
                            bind: {
                                credential: resp.data,
                            },
                            size: "contents",
                        });

                    },
                    opts: {
                        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    }
                });
            }

            if (this.not_shared) {
                cmp.$dialog.alert('Organisation has not shared credential access', 'Failed');
            } else if (this.skip_password_check) {
                _viewCred(null, "Failed to load credential, please try again.");
            } else {
                this.$dialog.promptPassword("Please enter your AppCheck login password to view the credential.", "Password", '', function (passwordValue) {
                    _viewCred(passwordValue, "Your password was incorrect, please try again.");
                });
            }
        },

        editCred(row) {
            const cmp = this;
            if (this.not_shared) {
                cmp.$dialog.alert('Organisation has not shared credential access', 'Failed');
                return;
            }
            this.$lightbox.open({
                title: "Edit Credential",
                component: CredentialManagerFormSSR,
                bind: { url: '/credman/credentials/' + row.raw.uuid + '/update', newCred: false, isLightbox: true },
                on: {
                    close: () => cmp.$refs.table.store.reload(),
                },
                size: "wide",
            });
        },

        deleteCred: function (row) {
            const cmp = this;
            const _deleteCred = function(passwordValue, failureMessage) {
                AjaxUtils.ajax_post({
                    url: `/credman/credentials/${row.raw.uuid}/delete`,
                    data: {
                        password: passwordValue,
                    },
                    success: function (resp) {
                        if (!resp.success) {
                            cmp.$dialog.alert(failureMessage, 'Failed');
                            return;
                        }

                        cmp.$refs.table.store.reload();
                        cmp.$flash({message: 'Successfully deleted credential'});
                    },
                    opts: {
                        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    }
                });
            }

            if (this.not_shared) {
                cmp.$dialog.alert('Organisation has not shared credential access', 'Failed');
            } else if (this.skip_password_check) {
                _deleteCred(null, "Failed to delete, please try again.");
            } else {
                this.$dialog.promptPassword("Please enter your AppCheck login password to delete the credential.", "Password", '', function (passwordValue) {
                    _deleteCred(passwordValue, "Your password was incorrect, please try again.");
                });
            }
        },

        selectCredential: function (rec) {
            const data = {}
            data.description = rec.get("description");
            data.uuid = rec.get("uuid");
            this.$emit("select", rec);
            this.$emit("close");
        },
        addCredential: function () {
            const cmp = this;
            this.$lightbox.open({
                title: "Add Credential",
                component: CredentialManagerFormSSR,
                bind: { url: "/credman/credentials/create", newCred: true, isLightbox: true, cred_type: this.cred_type },
                on: {
                    close: () => cmp.$refs.table.store.reload(),
                },
                size: "wide",
            });
        }
    },
    template: `
        <div class="new-ui">
            <apck-table
                ref="table"
                :columns="cols"
                :src="src"
                :sgl-row-action="selectCredential"
                :actions="actions"
                :new-style-table="true"
            >
                <template v-slot:tbar>
                    <ui-button
                        label="Add Credential"
                        type="primary"
                        icon-left="fa-plus"
                        @click="addCredential"
                    />
                </template>
            </apck-table>
        </div>
    `,
};

export const ApckCredentialImport = {
    props: {
        label: {
            type: String,
            default: ""
        },
        value: {
            type: String,
            default: ""
        },
        cred_type: {
            type: String,
            default: ""
        },
        skip_password_check: {
            type: Boolean,
            default: false,
        },
        not_shared: {
            type: Boolean,
            default: false,
        },
        selectButtonClass: {
            type: String,
            default: "btn-primary btn-big",
        },
        removeButtonClass: {
            type: String,
            default: "btn-negative btn-big",
        },
    },
    data: function () {
        return {
            localValue: "",
            cols: [
                { "data": "description", "heading": "Description", "canSearch": true },
                { "data": "type", "heading": "Type", "canSearch": true }
            ],
            description: "",
            actions: [{
                title: "Select",
                icon: "fa-plus",
                class: "btn-primary",
                handler: this.selectCredential
            }]
        };
    },
    computed: {
        url() {
            if (this.value) return '/credman/credentials_safe/' + this.value;
            return "";
        }
    },
    watch: {
        value(newValue) {
            this.loadName(newValue);
        },
    },
    mounted () {
        this.loadName(this.value);
    },
    methods: {
        loadName: function (newValue) {
            const cmp = this;
            if (newValue) {
                AjaxUtils.ajax_get({
                    url: cmp.url,
                    success(response) {
                        cmp.description = response.data.description;
                    },
                    fail() {
                        cmp.description = "Could not fetch credential, please refresh.";
                    },
                    opts: {flash_form_errors: false, flash_404_errors: false}
                });
            } else {
                cmp.description = "None selected";
            }
            // if (!cmp.description) {
            //     cmp.description = "None selected";
            // }
        },
        selectCredential: function (rec) {
            const uuid = rec.get("uuid");
            this.description = rec.get("description");
            this.$emit("input", uuid);
        },
        removeCredential: function () {
            this.$emit("input", "");
        },
        openCredential: function () {
            var src = "/credman/credentials";
            if (this.cred_type != "") {
                src = "/credman/credentials?type=" + this.cred_type;
            }
            this.$lightbox.open({
                title: "Select a credential",
                component: ApckModalCredentialSelect,
                bind: { src: src, skip_password_check: this.skip_password_check, not_shared: this.not_shared, cred_type: this.cred_type },
                on: {
                    select: this.selectCredential,
                },
                size: "wide",
            });
        },
        addCredential: function () {
            const cmp = this;
            this.$lightbox.open({
                title: "Create New Credential",
                component: CredentialManagerFormSSR,
                bind: { url: "/credman/credentials/create", newCred: true, isLightbox: true, cred_type: this.cred_type },
                on: {
                    close: () => cmp.openCredential(),
                },
                size: "wide",
            });
        }
    },
    template: `
    <div class="goscript-import-col">
        <label
            v-if="label"
            class="label"
        >
            {{ label }}
        </label>
        <div class="goscript-import-field">
            <input type="text" disabled :value="description" />
            <apck-button
                v-if="!value"
                title="Select Credential"
                value="Select Credential"
                icon="fa-folder-open"
                :class="selectButtonClass"
                :handler="openCredential"
            />
            <apck-button
                v-if="value"
                title="Remove Credential"
                value="Remove Credential"
                icon="fa-trash"
                :class="removeButtonClass"
                :handler="removeCredential"
            />
            <apck-button
                v-if="!value"
                title="Create New Credential"
                value="Create New Credential"
                icon="fa-plus"
                :class="selectButtonClass"
                :handler="addCredential"
            />
        </div>
    </div>
    `,
}

export const ApckCredentialImportWrapper = {
    components: {
        'apck-credential-import': ApckCredentialImport,
    },
    props: {
        value: {
            type: String,
            default: ""
        },
        name: {
            type: String,
            default: ""
        },
        cred_type: {
            type: String,
            default: ""
        },
        skip_password_check: {
            type: Boolean,
            default: false,
        },
        not_shared: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        // add mutation observer for input update events
        const observer = new MutationObserver(() => {
            const updatedVal = this.$refs.input.value;
            if (updatedVal !== this.value) {
                this.value = updatedVal;
            }
        });
        observer.observe(this.$refs.input, {attributes: true, attributeFilter: ["value"]});
    },
    template: `
    <div class="form-field">
        <apck-credential-import v-model="value" :cred_type="cred_type" :skip_password_check="skip_password_check" :not_shared="not_shared" />
        <input type="hidden" :name="name" :value="value" ref="input">
    </div>
    `
}
